import styled from "styled-components";

// Largura do Sidebar da lib (o DEFAULT_SIDEBAR_WIDTH dela, que não é exportado)
export const SIDEBAR_WIDTH = "130px";

export const Root = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.N50};
`;

// Coluna à direita do Sidebar (fixo): Header, conteúdo e rodapé, como no ft-app-web
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  margin-left: ${SIDEBAR_WIDTH};
`;

// Sem usePageHeader (vitrine /dev/ow): largura até 1440px e 30px nas laterais, como o
// ContainerComponents da lib. As telas com usePageHeader trazem o próprio
// ContentPage/ContentBox, que fazem as laterais por dentro: aqui ficam sem recuo,
// como o conteúdo do ft-app-web. Só o estilo muda, para a tela não remontar.
export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: ${({ theme, $isLibPage }) => ($isLibPage ? "none" : theme.breakpoints.desktop)};
  margin: 0 auto;
  padding: ${({ $isLibPage }) => ($isLibPage ? "0" : "0 30px 30px")};
`;
